import { render, staticRenderFns } from "./nowDistributorRed.vue?vue&type=template&id=9283fec8&scoped=true"
import script from "./nowDistributorRed.vue?vue&type=script&lang=js"
export * from "./nowDistributorRed.vue?vue&type=script&lang=js"
import style0 from "./nowDistributorRed.vue?vue&type=style&index=0&id=9283fec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9283fec8",
  null
  
)

export default component.exports